import styled from "styled-components";
import { Grid } from "@mui/material";
import { theme } from "styles/mui-config";
import Button from "@mui/material/Button";
import image from "assets/img/slide_back.jpg";
import Slider from "react-slick";

export const StyledSlider = styled(Slider)`
  .slick-slide {
    // padding: 10px;
  }

  & > .Nextarrow {
    position: absolute;
    bottom: 0px;
    right: 120px;
    z-index: 1;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-delay: 0.5s;
    opacity: 0;
    cursor: pointer;
    @media (max-width: 900px) {
      display: none;
    }
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      left: 0;
      right: 0;
      position: static;
      transform: translate(0, 0);
      transform: rotate(180deg);
      font-size: 21px;
      margin-right: 3px;
    }
    &:hover {
      background: #f1f1f1;
      box-shadow: 0px 0px 6px 0px #cecece;
    }
  }
  &:hover .Nextarrow {
    opacity: 1;
    transition-delay: 0s;
    bottom: 30px;
  }
  & > .Prevarrow {
    position: absolute;
    bottom: 10px;
    right: 65px;
    z-index: 1;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-delay: 0.5s;
    opacity: 0;
    cursor: pointer;
    @media (max-width: 900px) {
      display: none;
    }
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      left: 0;
      right: 0;
      position: static;
      transform: translate(0, 0);
      font-size: 21px;
      margin-left: 3px;
    }
    &:hover {
      background: #f1f1f1;
      box-shadow: 0px 0px 6px 0px #cecece;
    }
  }
  &:hover .Prevarrow {
    opacity: 1;
    transition-delay: 0s;
    bottom: 30px;
  }
`;

export const StyledButton = styled(Button)`
  width: 200px !important;
  background: white !important;
  color: ${theme.palette.primary.dark} !important;
  border: 1px solid white !important;
  margin-top: 17px !important;
  & svg {
    margin-left: 10px;
  }
  & hover {
    background: #003442 !important;
  }
`;

export const StyledButton2 = styled(Button)`
  width: 200px !important;
  color: white !important;
  border: 1px solid white !important;
  margin-top: 17px !important;
  margin-right: 20px !important;
  @media (max-width: 462px) {
    margin-right: 0px !important;
  }
  & svg {
    margin-left: 10px;
  }
  & hover {
    background: #003442 !important;
  }
`;

export const StyledButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 570px) {
    & button {
      margin-left: 0px !important;
    }
  }
  @media (max-width: 462px) {
    flex-direction: column;
    margin-right: 0px !important;
  }
`;
export const StyledDiv = styled.div`
  // min-height: 100vh;
  // background: linear-gradient(
  //   190deg,
  //   #04c1f3 49.93%,
  //   #009ac2 85.84%
  // ) !important;
  // height: 579px;
  // background-image: url(${image}) !important;
  // background-color: #149fc4;
  // background-size: cover;
  // background-position: center;
  // position: relative;
  // top: -109px;
  z-index: -1;
  direction: rtl;
  // padding-top: 20px;
  // padding-bottom: 20px;
  // padding-right: 30px;
  // padding-left: 30px;
  // display: flex;
  // align-items: center;
  // & > div {
  //   height: 100%;
  // }
  // & > div > div {
  //   height: 100%;
  // }
  // & > div > div > div {
  //   height: 100%;
  // }
  // @media (max-width: 900px) {
  //   padding-bottom: 20px;
  // }
  // @media (max-width: 440px) {
  //   height: 379px;
  // }
`;
export const StyledGridTop = styled(Grid)`
  flex-direction: column !important;
  margin-top: 30px !important;
  @media (max-width: 900px) {
    display: none;
  }
`;

export const StyledImg = styled.img`
  width: auto !important;
  height: 644px !important;
  padding: 60px;
  padding-top: 10px;
  @media (max-width: 980px) {
    padding-right: 0;
    padding-left: 0;
  }
  // @media (max-width: 500px) {
  //   padding: 0px;
  // }
  @media (max-width: 440px) {
    padding: 0px;
    height: 380px !important;
  }
  @media (max-width: 300px) {
    width: 98% !important;
    height: auto !important;
  }
`;

export const Styledh2 = styled.h2`
  color: white;
  font-size: 50px;
  font-family: "Avini";
  margin: 0;
  @media (max-width: 900px) {
    font-size: 30px;
    text-align: center;
  }
`;

export const Styledp = styled.p`
  color: white;
  font-size: 18px;
  text-align: justify;
  line-height: 40px;
  margin-top: 0px;
  padding: 10px;
`;
